import type { Browser, DeviceType } from '@/interfaces/base.interface';

export const getDeviceType = (): DeviceType => {
  const userAgent = navigator.userAgent;

  let browser: Browser = 'ECT';

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    if (/CriOS/.test(userAgent)) {
      browser = 'CHROME';
    } else if (/Safari/.test(userAgent) && !/CriOS/.test(userAgent)) {
      browser = 'SAFARI';
    } else if (/KAKAOTALK/.test(userAgent)) {
      browser = 'KAKAO';
    }
    return {
      browser,
      device: 'IOS'
    };
  }

  if (/android/i.test(userAgent)) {
    if (/Chrome/.test(userAgent)) {
      browser = 'CHROME';
    } else if (/SamsungBrowser/.test(userAgent)) {
      browser = 'SAMSUNG';
    } else if (/KAKAOTALK/.test(userAgent)) {
      browser = 'KAKAO';
    }
    return {
      browser,
      device: 'ANDROID'
    };
  }

  return {
    browser,
    device: 'WEB'
  };
};

export const isWindowAgent = (userAgent: NavigatorID['userAgent']) => {
  return userAgent.indexOf('Windows ') > -1;
};
